<template>
    <div>
        <h3 class="mar-t-0">1.基础配置</h3>
        <div class="border-card">
<!--            <el-form-item label="规则计时开始时间" class="basis-config-item">-->
<!--                <el-tooltip class="item" effect="dark" content="登录限制规则当日计时的开始时间" placement="top">-->
<!--                    <i class="el-icon-question"></i>-->
<!--                </el-tooltip>-->
<!--                <span class="span-pad">：</span>-->
<!--                <el-time-select-->
<!--                    placeholder="起始时间"-->
<!--                    size="mini"-->
<!--                    class="w120"-->
<!--                    v-model="params.regular_timing_from"-->
<!--                    v-if="is_configured"-->
<!--                    :picker-options="{-->
<!--                                start: '00:00',-->
<!--                                step: '00:15',-->
<!--                                end: '24:00',-->
<!--                            }">-->
<!--                </el-time-select>-->
<!--                <span v-else>{{params.regular_timing_from}}</span>-->
<!--            </el-form-item>-->
            <el-form-item label="即将离线提示时间" class="basis-config-item" prop="force_offline_notice_before_minutes"><span class="span-pad">：</span>
                离线前
                <el-input-number
                    class="w70"
                    size="mini"
                    :min="0"
                    :max="60"
                    :controls="false"
                    v-if="is_configured"
                    :precision="0"
                    v-model="params.force_offline_notice_before_minutes"
                ></el-input-number>
                <span v-else>{{params.force_offline_notice_before_minutes}}</span>
                min，弹窗提示玩家即将离线
            </el-form-item>
        </div>
    </div>
</template>

<script>
export default {
    name: "basisConfig",
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        is_configured: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// website/subComponents/antiAddiction/basisConfig.vue